'use strict';

import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import styles from './assets/indexResponse.module.css';
import './assets/private_header.css';


const print = function (value) { };
class DDS_lanhupage_Header extends Component {
  state = {};
  setValue(val) { }

  pageResh = (value) => {
    window.setTimeout(() => {
      let url = window.location.href;
      let index = url.indexOf("#");
      if (index > 0) {
        let returnstr = url.substring(index + 1);
        switch (returnstr) {
          case "step1":
            document.querySelector('#step1').scrollIntoView({ behavior: 'smooth' });
            break;
          case "step2":
            document.querySelector('#step2').scrollIntoView({ behavior: 'smooth' });
            break;
          case "step3":
            document.querySelector('#step3').scrollIntoView({ behavior: 'smooth' });
            break;
        }
      }

    }, 200)


  }
  onRetrunBottom = () => {
    document.getElementById('footer').scrollIntoView({ behavior: 'smooth' });
  }


  render() {
    return (
      <div className={`${styles['section_1']} flex-col indexResponse_section_1__f0gVZ indexResponse_section_1__g6BUm visible`}>

        <div className={`${styles['section_9']} flex-row justify-between indexResponse_section_9__3IxsO visible`}>
          <div style={{ display: 'flex' }}>

            {/* <img
              className={`${styles['image_2']} indexResponse_image_2__1yXrr indexResponse_image_2__3GE9h`}
              src={
                require('./assets/img/weblog.png')
              }
            /> */}
            <img
              className={`${styles['image_2']} indexResponse_image_2__1yXrr indexResponse_image_2__3GE9h`}
              src={
                require('./assets/img/u2u.png')
              }
            />

          </div>
          <div className='flex-row visible'>
            <span className={`${styles['text_1']} indexResponse_text_1__3KntK`} >
              {this.props.activeMenu == "0" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link to="/" className={this.props.activeMenu == "0" ? 'active' : ''}>首页</Link></span>

            <span className={`${styles['text_2']} menuitem indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "1" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV index_res`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link className={this.props.activeMenu == "1" ? 'active' : ''}>国际合作项目</Link>
              <div class="menu-child text-base menu-child-expand">
                <Link to='/convoy/9'><div class="menu-child-item d-flex-center">教育部SQA（3+1）</div></Link>
                <Link to='/convoy/10'><div class="menu-child-item d-flex-center">中外合作办学计划外</div></Link>
                <Link to='/convoy/11'><div class="menu-child-item d-flex-center">国际本科1+3</div></Link>
                <Link to=''><div class="menu-child-item d-flex-center">国际硕博及非英语系国家项目
                  <div class="menu-child-second text-base">
                    <Link to='/Project/Ma'><div class="menu-child-item d-flex-center">马来西亚硕博</div></Link>
                    <Link to='/Project/Es'><div class="menu-child-item d-flex-center">西班牙本硕</div></Link>
                    <Link to='/Project/Fr'><div class="menu-child-item d-flex-center">法国本硕</div></Link>
                    <Link to='/Project/Sg'><div class="menu-child-item d-flex-center">新加坡硕士</div></Link>
                    <Link to='/Project/Au'><div class="menu-child-item d-flex-center">澳洲</div></Link>
                  </div>
                </div>
                </Link>
              </div>
            </span>




            <span className={`${styles['text_2']} menuitem indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "8" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV indexResponse_section_8__CEYtad`}>
                <div className={`${styles['box_1']} indexResponse_box_1__2J0Dn  flex-col indexResponse_box_1__1FnRE indexResponse_box2_long`} />
              </div>
              }

              <Link to='' className={this.props.activeMenu == "8" ? 'active' : ''}>国际语言考试与联盟协作</Link>
              <div class="menu-child text-base">

                <Link to=''>
                  <div class="menu-child-item d-flex-center">
                    国际语言
                    <div class="menu-child-second text-base">
                      <Link to='/convoy/12'><div class="menu-child-item d-flex-center">国际语言课程</div></Link>
                      <Link to='/Jituan'><div class="menu-child-item d-flex-center">学习集团介绍</div></Link>
                    </div>
                  </div>
                </Link>
                <Link to='/convoy/13'>
                  <div class="menu-child-item d-flex-center">
                    联盟协作
                  </div>
                </Link>
                <Link to=''>
                  <div class="menu-child-item d-flex-center">
                    国际合作与交流
                    <div class="menu-child-second text-base">
                      <Link to='/upm'><div class="menu-child-item d-flex-center">UPM 2025音乐夏令营</div></Link>
                      <Link to='/frnisi'><div class="menu-child-item d-flex-center">法国尼斯夏令营2025</div></Link>
                      <Link to='/sgsummer'><div class="menu-child-item d-flex-center">新加坡研学夏令营2025</div></Link>
                      <Link to='/sgwinter'><div class="menu-child-item d-flex-center">新加坡研学冬令营2025</div></Link>
                    </div>
                  </div>
                </Link>

              </div>
            </span>



            {/* <span className={`${styles['text_2']} indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "2" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} indexResponse_box_1__2J0Dn  flex-col indexResponse_box_1__1FnRE`} />
              </div>
              }
              <Link to='' className={this.props.activeMenu == "2" ? 'active' : ''}>中外合作办学（计划内）</Link></span> */}

            {/* <span className={`${styles['text_2']} indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "3" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} indexResponse_box_1__2J0Dn  flex-col indexResponse_box_1__1FnRE`} />
              </div>
              }
              <Link to='/country' className={this.props.activeMenu == "3" ? 'active' : ''}>护航计划共建单位申请</Link></span> */}



            <span className={`${styles['text_2']} indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "5" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} indexResponse_box_1__2J0Dn  flex-col indexResponse_box_1__1FnRE`} />
              </div>
              }
              <Link to='/country' className={this.props.activeMenu == "5" ? 'active' : ''}>选择国家</Link></span>
            {/* <span className={`${styles['text_2']} menuitem indexResponse_text_2__2IG7N`}>
              {this.props.activeMenu == "6" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link className={this.props.activeMenu == "6" ? 'active' : ''}>选择项目</Link>
              <div class="menu-child text-base">
                <Link to='/Project/Ma'><div class="menu-child-item d-flex-center">马来西亚硕博</div></Link>
                <Link to='/Project/Es'><div class="menu-child-item d-flex-center">西班牙本硕</div></Link>
                <Link to='/Project/Fr'><div class="menu-child-item d-flex-center">法国本硕</div></Link>
                <Link to='/Project/Sg'><div class="menu-child-item d-flex-center">新加坡硕士</div></Link>
                <Link to='/Project/Au'><div class="menu-child-item d-flex-center">澳洲</div></Link>
              </div>
            </span> */}
            <span className={`${styles['text_4']} indexResponse_text_4__14rIE`}>
              {this.props.activeMenu == "7" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link to='/universities' className={this.props.activeMenu == "7" ? 'active' : ''}>选择大学</Link></span>

            <span className={`${styles['text_4']} indexResponse_text_4__14rIE`}>
              {this.props.activeMenu == "9" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link to='/convoy/1' className={this.props.activeMenu == "9" ? 'active' : ''}>护航计划</Link></span>


            {/* <span className={`${styles['text_4']} menuitem indexResponse_text_5__14rIE`}>
              {this.props.activeMenu == "8" && <div className={`${styles['section_8']} flex-row indexResponse_section_8__CEYtV`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link className={this.props.activeMenu == "8" ? 'active' : ''}>国际合作与交流</Link>
              <div class="menu-child text-base">
                <Link to='/upm'><div class="menu-child-item d-flex-center">UPM 2025音乐夏令营</div></Link>
                <Link to='/frnisi'><div class="menu-child-item d-flex-center">法国尼斯夏令营2025</div></Link>
                <Link to='/sgsummer'><div class="menu-child-item d-flex-center">新加坡研学夏令营2025</div></Link>
                <Link to='/sgwinter'><div class="menu-child-item d-flex-center">新加坡研学冬令营2025</div></Link>
              </div>
            </span> */}

            {/* <span className={`${styles['text_5']} indexResponse_text_5__ZAx0-`}>
              {this.props.activeMenu == "5" && <div className={`${styles['section_8']} flex-row`}>
                <div className={`${styles['box_1']} flex-col indexResponse_box_1__2J0Dn `} />
              </div>
              }
              <Link className={this.props.activeMenu == "5" ? 'active' : ''} onClick={() => this.onRetrunBottom()}>联系我们</Link></span> */}
            {/* <div className={`${styles['group_1']} flex-col indexResponse_group_1__3CBm`} />
            <span className={`${styles['text_6']} indexResponse_text_6__3bpep`}>010-57528293</span> */}
            <div className="flex-col dv_ico_enter" />
            <span className={`${styles['text_6']} indexResponse_text_6__2vio4`}><Link onClick={() => {
              window.open("https://sjtuilearning.imasedu.com/", '_blank');
            }}>开始学习</Link></span>
          </div>
        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_Header;
